// extracted by mini-css-extract-plugin
export default {"quillEditorGroup":"TextEditor_quillEditorGroup__M8l1g","quill":"TextEditor_quill__kH3x8","bubbleEditor":"TextEditor_bubbleEditor__vITGV"};